import {BaseAttribute} from "@/pages/AppPages/Events/attribute";

export class ExaminationEventAttributes extends BaseAttribute {

    constructor(initObjectParams) {
        super(initObjectParams)
        this.vetSpecialist = null;
        this.conclusion = null;
    }

    static get modelName() {
        return 'ClinicalEvent'
    }

    static get validations() {
        return {
            vetSpecialist: {},
            conclusion: {},
        }
    }

    static get validationFieldLabels() {
        return {
            vetSpecialist: 'Ветеринар',
            conclusion: 'Заключение'
        }
    }

    static get mapping() {
        return {}
    }

    static get label() {
        return ''
    }

    static get newLabel() {
        return ''
    }

    objectLabel() {
        return ''
    }

    applyData(data) {
        this.vetSpecialist = data['vetSpecialist'];
        this.conclusion = data['conclusion'];
    }

}